export default {"src":"/_next/static/media/top-arrow.723de87d.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};